module.exports = __webpack_public_path__ + "img/wyjj.e7d7c996.png";